import {useGetOpinionsListQuery} from '../queries/useGetOpinionsListQuery';

export const useOpinions = () => {
	const {data, isError, isLoading, refetch} = useGetOpinionsListQuery();
	const isEmpty = !data?.content || data?.content?.length === 0;
	return {
		data: data?.content,
		isEmpty,
		isLoading,
		isError,
		refetch,
	};
};
